import React, { useEffect, useState } from "react";
import PdfPrinter from "pdfmake";
import { useOrganization } from "../../configurations/OrganizationContext";
import { useDispatch } from "react-redux";
import { doctorActions } from "../../core/actions";
import { PRINT_FILE, PRINT_PREVIEW } from "../../shared/constants";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { HOSPITAL_NAME, HOSPITAL_ADDRESS, PHONE_NO } from "../../mnh/index";
import { MNH_LOGO } from "../../mnh/mnhlogo";

PdfPrinter.vfs = pdfFonts.pdfMake.vfs;

function PrintMnhDischargeSummary(props) {
  const dispatch = useDispatch();
  console.log("PrintMnhDischargeSummary props:", props);
  const org = useOrganization();
  const [printPreviewType] = useState(props.printPreviewType);
  const [departmentList, setDepartment] = useState([]);

  useEffect(() => {
    console.log("PrintMnhDischargeSummary component mounted");
    props.parentCallBack();

    // Fetch department list first, then generate print
    dispatch(
      doctorActions.getDepartmentList({}, (resCb) => {
        if (resCb) {
          const deptlist = resCb.map(dept => ({
            id: dept.id,
            name: dept.name,
          }));
          setDepartment(deptlist);
          console.log("departmentLists:::::", deptlist);

          // Generate print after department list is loaded
          generatePrint(deptlist);
        }
      })
    );
  }, []);

  const extractData = (deptList) => {
    const isOn = props.isOn;
    const resCb = props.patientdetails.resCb;
    console.log("resCb in extractData:", resCb);
    const summary = props.summary;
    const city = resCb.city;
    const state = resCb.state;
    const pincode = resCb.pincode;

    const Address =
      (resCb.address ? resCb.address + ", " : "") +
      (city ? city : "Mangalore") +
      (state ? ", " + state : ", Karnataka") +
      (pincode ? " " + pincode : "");

    const patient_name = `${resCb.fname || ""} ${resCb.mname || ""} ${resCb.lname || ""}`;
    const IP_number = resCb.visit.ipopnumber || "";
    const Register_No = resCb.id;
    const Age = resCb.age || "";
    const Sex = resCb.gender || "";

    const roomList = resCb.roomList || [];
    const Room_Number = roomList.map(room => room.roomName).join(", ");

    const deptId = resCb.visit.department;

    // Find matching department name from the passed department list
    const Department_Unit = deptList.find(d => d.id === deptId)?.name || "-";
    console.log("Department ID:", deptId, "Department Name:", Department_Unit);

    const Patient_Status = summary["Patient Status"];
    const Referred_By = summary["Referred By"];
    const Referred_To = summary["Referred To"];

    const Date_of_addmission = new Date(resCb.registeredOn).toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });

    let DATE_of_discharge = "";
    if (summary.dischargedt) {
      DATE_of_discharge = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      }).format(new Date(summary.dischargedt));
    } else {
      DATE_of_discharge = new Date().toLocaleString("en-US");
    }

    return {
      patient_name,
      IP_number,
      Register_No,
      Age,
      Sex,
      Department_Unit,
      Room_Number,
      Patient_Status,
      Referred_To,
      Referred_By,
      DATE_of_discharge,
      Address,
      Date_of_addmission,
      doctorList: props.doctorList,
      summary,
      isOn,
      treatingDoctor: props.treatingDoctor || "",
      customFields: props.customFields || [],
      enteredBy: props.enteredBy || "",
    };
  };

  const generatePrint = (deptList) => {
    const data = extractData(deptList);
    console.log("Extracted data for printing:", data);

    if (printPreviewType === PRINT_FILE) {
      printAsHtml(data);
    } else if (printPreviewType === PRINT_PREVIEW) {
      previewAsPdf(data);
    } else {
      console.warn("Unknown printPreviewType:", printPreviewType);
    }
  };

  const printAsHtml = (data) => {
    console.log("Printing as HTML with data:", data);

    // Helper function to strip HTML tags
    const stripHtml = (html) => {
      if (!html) return '-';
      const text = String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return text || '-';
    };

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Discharge Summary</title>
      <style>
        body {
          font-family: Arial, Helvetica, sans-serif;
          margin: 40pt;
          padding: 0;
          font-size: 9pt;
          line-height: 1.4;
        }
        .header {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 15pt;
          width: 100%;
        }
        .logo {
          width: 80px;
          text-align: center;
        }
        .hospital-info {
          flex: 1;
          text-align: left;
          margin-left: 15pt;
        }
        .hospital-name {
          font-size: 16pt;
          font-weight: bold;
          text-align: center;
        }
        .hospital-address {
          font-size: 10pt;
          text-align: center;
        }
        .hospital-contact {
          font-size: 8pt;
          text-align: center;
        }
        .title {
          text-align: center;
          font-size: 12pt;
          font-weight: bold;
        }
        .info-table {
          width: 100%;
          border-collapse: collapse;
          margin: 0 0 10pt 0;
          table-layout: fixed;
        }
        .info-table td {
          padding: 2.5pt 2pt;
          vertical-align: middle;
          font-size: 9pt;
          line-height: 1.2;
        }
        .info-table tr {
          height: 18pt;
        }
        .label {
          font-weight: bold;
          width: 20%;
          white-space: nowrap;
        }
        .separator {
          width: 5%;
          text-align: right;
          padding-right: 4pt;
        }
        .value {
          width: 25%;
        }
        .divider {
          width: 100%;
          height: 1pt;
          background-color: #000;
          margin: 5pt 0 0 0;
        }
          .section-divider {
  width: 100%;
  border-top: 1pt solid #000;
  margin: 8pt 0 6pt 0;
}

       .section-title {
  font-size: 10pt;
  font-weight: bold;
  line-height: 1;
  margin: 3pt 0 0 0;
}

.section-content {
 margin-top:-10px;
}

        .signature {
          margin: 15pt 0 2pt 0;
          font-size: 10pt;
        }
        @media print {
          @page {
            size: A4;
            margin: 0;
          }
          body {
            margin: 40pt;
          }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%; gap: 20pt;">
          <img src="${MNH_LOGO}" class="logo" alt="Hospital Logo" />
          <div class="hospital-info">
            <div class="hospital-name">${HOSPITAL_NAME}</div>
            <div class="hospital-address">${HOSPITAL_ADDRESS}</div>
            <div class="hospital-contact">Ph.: ${PHONE_NO} Fax: 0824 - 2218483</div>
          </div>
        </div>
      </div>

      <div class="title">DISCHARGE SUMMARY</div>

      <table class="info-table">
        <tr>
          <td class="label">IP No.</td>
          <td class="separator">:</td>
          <td class="value">${data.IP_number || '-'}</td>
          <td class="label">Register No.</td>
          <td class="separator">:</td>
          <td class="value">${stripHtml(data.Register_No)}</td>
        </tr>
        <tr>
          <td class="label">Patient Name</td>
          <td class="separator">:</td>
          <td class="value">${data.patient_name || '-'}</td>
          <td class="label">Doctor Name</td>
          <td class="separator">:</td>
          <td class="value">${data.doctorList && data.doctorList.length > 0 ? data.doctorList[0] : '-'}</td>
        </tr>
        <tr>
          <td class="label">Age</td>
          <td class="separator">:</td>
          <td class="value">${data.Age || '0'} Yrs, Sex: ${data.Sex || '-'}</td>
          <td class="label">Room No.</td>
          <td class="separator">:</td>
          <td class="value">${data.Room_Number || '-'}</td>
        </tr>
        <tr>
          <td class="label">Address</td>
          <td class="separator">:</td>
          <td class="value">${data.Address || '-'}</td>
          <td class="label">Department/Unit</td>
          <td class="separator">:</td>
          <td class="value">${stripHtml(data.Department_Unit)}</td>
        </tr>
        <tr>
          <td class="label">Admission Date & Time</td>
          <td class="separator">:</td>
          <td class="value">${data.Date_of_addmission || '-'}</td>
          <td class="label">Discharge Date & Time</td>
          <td class="separator">:</td>
          <td class="value">${data.DATE_of_discharge || '-'}</td>
        </tr>
        <tr>
          <td class="label">Patient Status</td>
          <td class="separator">:</td>
          <td class="value">${stripHtml(data.Patient_Status)}</td>
          <td class="label">Referred To</td>
          <td class="separator">:</td>
          <td class="value">${stripHtml(data.Referred_To)}</td>
        </tr>
        <tr>
          <td class="label">Referred By</td>
          <td class="separator">:</td>
          <td class="value">${stripHtml(data.Referred_By)}</td>
          <td class="label"></td>
          <td class="separator"></td>
          <td class="value"></td>
        </tr>
      </table>

    ${[
        { key: "Final Diagnosis", title: "FINAL DIAGNOSIS:", addDivider: true },
        { key: "Chief Complaints", title: "CHIEF COMPLAINTS:" },
        ...(data.isOn ? [
          { key: "Obstetric history", title: "OBSTETRIC HISTORY:" },
          { key: "Menstrual history", title: "MENSTRUAL HISTORY:" },
          { key: "History of present pregnancy", title: "HISTORY OF PRESENT PREGNANCY:" },
        ] : [
          { key: "History of presenting illness", title: "HISTORY OF PRESENTING ILLNESS:" }
        ]),
        { key: "Past History", title: "PAST HISTORY:" },
        { key: "Family History", title: "FAMILY HISTORY:" },
        { key: "Drug Allergy", title: "DRUG ALLERGY:" },
        { key: "Provisional Diagnosis", title: "PROVISIONAL DIAGNOSIS:" },
        { key: "Investigations", title: "INVESTIGATION:" },
        { key: "General physical examination", title: "GENERAL PHYSICAL EXAMINATION:" },
        { key: "Systemic Examination", title: "SYSTEMIC EXAMINATION:" },
        { key: "Treatment given", title: "TREATMENT GIVEN:" },
        { key: "Course in the hospital", title: "COURSE IN THE HOSPITAL:" },
        { key: "Advice on discharge", title: "ADVICE ON DISCHARGE:" }
      ].map(section => {
        const content = data.summary[section.key] || '-';
        return `
    ${section.addDivider ? `<div class="section-divider"></div>` : ''}
    <div class="section-title">${section.title}</div>
    <div class="section-content">${content}</div>
  `;
      }).join('')}


      ${data.customFields
        .filter(field => data.summary[field.key] && data.summary[field.key].trim() !== '')
        .map(field => {
          const content = data.summary[field.key] || '-';
          return `
            <div class="section-title">${field.name.toUpperCase()}:</div>
            <div class="section-content">${content}</div>
          `;
        }).join('')}

      <div class="section-title">FOLLOW UP:</div>
      <div class="section-content">${data.summary["Follow Up"] || '-'}</div>

      <div class="section-title">IN CASE EMERGENCY CONTACT:</div>
      <div class="section-content">${data.summary["Emergency Contact"] || '-'}</div>

      <div style="font-size: 10pt; font-weight: bold; margin: 20pt 0 5pt 0;">TREATING DOCTOR SIGNATURE:</div>
      ${Array.isArray(data.treatingDoctor)
        ? data.treatingDoctor.map(name => `<div style="font-size: 10pt; margin: 15pt 0 2pt 0;">${name}</div>`).join('')
        : `<div style="font-size: 10pt; margin: 15pt 0 2pt 0;">${data.treatingDoctor || '-'}</div>`}

      <div class="section-title">ENTERED BY:</div>
      <div style="font-size: 9pt; margin: 0 0 8pt 0;">${data.enteredBy || '-'}</div>
    </body>
    </html>
  `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.zIndex = '-1';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('tabindex', '-1');

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();

    let hasPrinted = false;

    const triggerPrint = () => {
      if (hasPrinted) return;
      hasPrinted = true;

      const iframeWin = iframe.contentWindow;
      iframeWin.focus();
      iframeWin.print();

      const removeIframe = () => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      };

      if ('onafterprint' in iframeWin) {
        iframeWin.onafterprint = removeIframe;
      } else {
        setTimeout(removeIframe, 3000);
      }
    };

    iframe.onload = () => {
      setTimeout(triggerPrint, 500);
    };

    setTimeout(() => {
      if (!hasPrinted && document.body.contains(iframe)) {
        triggerPrint();
      }
    }, 2000);
  };

  const previewAsPdf = (data) => {
    import("../../mnh/docdefdischargeprint")
      .then(({ getDocDefinition }) => {
        const docDefinition = getDocDefinition(data);
        PdfPrinter.createPdf(docDefinition).open();
      })
      .catch(err => {
        console.error("Failed to load PDF definition for preview", err);
      });
  };

  if (!props.patientdetails) {
    return <div>Loading...</div>;
  }

  return <div style={{ display: "none" }}>Generating discharge summary...</div>;
}

export default PrintMnhDischargeSummary;